import React from 'react';

// External Components
import { Box } from '@thepuzzlers/pieces';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export const ImageContainer = ({
  designatedRef,
  className,
  src,
  imageAlt,
  sx,
  imageSx,
  imgProps,
  imgStyle,
  ...props
}) => (
  <Box
    ref={designatedRef}
    className={`image-container ${className}`}
    sx={{
      position: 'relative',
      ...sx
    }}
    {...props}>
    <GatsbyImage
      className="gatsby-image"
      {...imgProps}
      image={getImage(src)}
      alt={imageAlt ? imageAlt : ''}
      style={{ height: '100%', width: '100%', ...imageSx }}
      imgStyle={imgStyle}
    />
  </Box>
);
